import React, { useContext, useEffect, useState, useRef } from 'react';
import Logo from '../../../../Assets/Images/logo.png';
import String from '../../../../Assets/Localization/Local';
import './UpperHeader.css';
import { NavDropdown, Form, FormControl, Button, Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { LangContext, userCookieContext, userSessionContext, Notifcations } from '../../../../App'
import { FormContext } from '../../../../App'
import cookie from 'react-cookies'
import LoginForm from '../../../../Views/Auth/Login/login'
import SocketClient from "../../../../socketIo"
// export const FormContext = React.createContext();
let user = cookie.load('HBUser')
// let activeCase = [false, false, false, false, false, false]
const UpperHeader = (props) => {


  let HBUser_cookie = cookie.load("HBUser");
  let HBUser_sessionStorage = sessionStorage.getItem("HBUser");
  let disAppearLinkRef1 = useRef(null);
  let disAppearLinkRef2 = useRef(null);
  let disAppearLinkRef3 = useRef(null);
  let registerRef = useRef(null);
  let profileRef = useRef(null);
  let notificationRef=useRef(null);
  const { lang, changeLang } = useContext(LangContext)
  const { userCookie, handleUserCookie } = useContext(userCookieContext)
  const { userSession, handleUserSession } = useContext(userSessionContext)
  const [activeCase, setActiveCase] = useState([true, false, false, false, false, false])
  const { openForm, ToggleForm } = useContext(FormContext)
  const [scroll, setScroll] = useState(false)
  const [openMenu, setOpenMenu] = useState(false)   // false mean menu close
  const [smallScreen, setSmallScreen] = useState(false)
  const {count}=useContext(Notifcations)
  // const { data } = useContext(CompanyData)



  String.setLanguage(lang);

  console.log('ooooo--> ', window.location.pathname,Notifcations,count)
  useEffect(() => {

    console.log('userCookie----mm? ', userCookie, userSession)
    if (HBUser_cookie === undefined && (JSON.stringify(HBUser_sessionStorage) === null || JSON.stringify(HBUser_sessionStorage) === "null")) {

      disAppearLinkRef1.style.display = 'none';
      disAppearLinkRef2.style.display = 'none';
      disAppearLinkRef3.style.display = 'none';
      registerRef.style.display = "block";
      profileRef.style.display = "none";
      notificationRef.style.display="none";
    }
    else {
      disAppearLinkRef1.style.display = 'block';
      disAppearLinkRef2.style.display = 'block';
      disAppearLinkRef3.style.display = 'block';
      registerRef.style.display = "none";
      profileRef.style.display = "block";
      notificationRef.style.display="block";
    }
  })

  useEffect(() => {

    console.log("window.screen.availWidth==> ", window.innerWidth)
    if (window.innerWidth <= 950) {
      setSmallScreen(true);
    }
    else {
      setSmallScreen(false);
    }
    window.addEventListener('scroll', () => {
      // console.log("window parameters--> ", window)
      if (window.scrollY >= 200) {
        setScroll(true)
      }
      else {
        setScroll(false)
      }
    })
  })

  const handleActiveCase = (index) => {
    let arr = activeCase
    for (let i = 0; i < arr.length; i++) {
      if (i === index) {
        arr[i] = true
      }
      else {
        arr[i] = false
      }
    }
    console.log('arre----> ', arr)
    setActiveCase(arr)
  }

  const ToggleMenu = () => {
    setOpenMenu(!openMenu);
  }

  return (
    <div className={scroll === true ? "isScrolled" : ""}>
      {/* <SocketClient /> */}
      <nav className="UpperHeader">
        <label for="check">
          <Link onClick={ToggleMenu} style={{ display: (openMenu === false && smallScreen === true) ? 'block' : 'none' }}> <i class="fas fa-bars" id="btn"  ></i> </Link>
          <Link onClick={ToggleMenu} style={{ display: (openMenu === true && smallScreen === true) ? 'block' : 'none' }}> <i class="fas fa-times" id="cancel"></i></Link>
        </label>
        <div className="LogoPart">
          <Link to="/HealthBook-Web/Home"><img src={Logo} /></Link>
        </div>
        <Row className="listContainer" style={{ display: smallScreen === true ? openMenu === true ? 'block' : 'none' : '' }}>
          <Col xl="7" lg="7" md="7" sm="12" className="ListPart">
            <ul className='firstList'>
              <li className={window.location.pathname === "/HealthBook-Web/Home" ? "ActiveItem" : ""}><Link to="/HealthBook-Web/Home" onClick={ToggleMenu}>{String.home}</Link></li>

              <li className={window.location.pathname === "/HealthBook-Web/about-us" ? "ActiveItem" : ""} ><Link to="/HealthBook-Web/about-us" onClick={ToggleMenu}>{String.aboutUs}</Link></li>

              <li ref={el => (disAppearLinkRef1 = el)} className={window.location.pathname === "/HealthBook-Web/ViewFamily" ? "ActiveItem" : ""} ><Link to="/HealthBook-Web/ViewFamily" onClick={ToggleMenu}>{String.Family}</Link></li>
              <li ref={el => (disAppearLinkRef2 = el)} className={window.location.pathname === "/HealthBook-Web/ViewChildren" ? "ActiveItem" : ""} ><Link to="/HealthBook-Web/ViewChildren" onClick={ToggleMenu}>{String.childern}</Link></li>

              <li ref={el => (disAppearLinkRef3 = el)} className={window.location.pathname === "/HealthBook-Web/ViewAnimals" ? "ActiveItem" : ""} ><Link to="/HealthBook-Web/ViewAnimals" onClick={ToggleMenu}>{String.animals}</Link></li>

              <li className={window.location.pathname === "/HealthBook-Web/contact-us" ? "ActiveItem" : ""}><Link to="/HealthBook-Web/contact-us" onClick={ToggleMenu}>{String.contactus}</Link></li>
            </ul>
          </Col>
          <Col xl="5" lg="5" md="5" sm="12" className="BtnsPart">
            <ul className="secondList">
              <li className="Language" style={{ marginRight: '0' }}>
                <NavDropdown title={lang === "ar" ? String.Arlang : String.Enlang} id="basic-nav-dropdown">
                  <NavDropdown.Item onClick={() => changeLang('en')} style={{ textAlign: 'center' }}>{String.Enlang}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={() => changeLang('ar')} style={{ textAlign: 'center' }}>{String.Arlang}</NavDropdown.Item>
                </NavDropdown>
              </li>
              <li className="LoginBtn" ref={el => (registerRef = el)} style={{ marginLeft: lang === "ar" ? '0px' : '15px', marginRight: lang === "en" ? '0px' : '15px' }}>
                <Link to="#" onClick={() => {
                  ToggleForm()
                  ToggleMenu()

                }} >{String.register}</Link>
              </li>
              <li className="notification mx-2" ref={el => (notificationRef = el)}>
              <Link to="/HealthBook-Web/Notifications" style={{color:"#fff"}}> <i class="fas fa-bell px-2"> {count!==0?count:null}</i>
              </Link>
              </li>
              <li className="LoginBtn" ref={el => (profileRef = el)} style={{ marginLeft: lang === "ar" ? '0px' : '15px', marginRight: lang === "en" ? '0px' : '15px' }}  >
                <Link to="/HealthBook-Web/Profile" onClick={() => {
                  ToggleMenu()
                }}>{String.profile}</Link>
              </li>
            </ul>
            {openForm && <LoginForm close={ToggleForm} />}
          </Col>
        </Row>
      </nav>
    </div >
  );
}

export default UpperHeader;
